import { Typography } from 'onboarding-components';

// @ts-strict-ignore
import { useTranslation } from 'common/i18n/hooks';
import common from '../common.module.styl';
export const StartCards = () => {
  const {
    t
  } = useTranslation();
  return <div className={common.container} data-sentry-component="StartCards" data-sentry-source-file="StartCards.tsx">
      <header className={common.px48}>
        <Typography variant='headingSm' data-sentry-element="Typography" data-sentry-source-file="StartCards.tsx">{t("onboarding.welcome.choose-start")}</Typography>
      </header>
    </div>;
};